'use client';

import { AppProgressProvider as ProgressProvider } from '@bprogress/next';

const ProgressBarProvider = ({ children }) => {
    return (
        <ProgressProvider
            height="2px"
            color="#0C42FF"
            options={{ showSpinner: false }}
            shallowRouting>
            {children}
            {/* <ProgressBar
                height="2px"
                color="#0C42FF"
                options={{ showSpinner: false }}
                shallowRouting
            /> */}
        </ProgressProvider>
    );
};

export default ProgressBarProvider;
